import Plot from "react-plotly.js";
import { Button, Icon, Message } from "semantic-ui-react";

function GraficoProcessosPorMes({ dados, onExpandir }) {
  if (!dados || dados.length === 0) {
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
          <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>Processos por Mês</div>
        </div>
        <Message info style={{ margin: 0 }}>
          Sem dados para exibir
        </Message>
      </div>
    );
  }

  const dadosTratados = dados.map((item) => {
    return {
      label: item.label?.trim() || item.mes || item.month || 'Sem data',
      valor: item.valor || item.value || item.count || 0,
    };
  });

  console.log('Dados tratados:', dadosTratados);

  // Ordenar por mês (assumindo formato YYYY-MM)
  const dadosOrdenados = [...dadosTratados].sort((a, b) => {
    if (a.label.match(/^\d{4}-\d{2}/) && b.label.match(/^\d{4}-\d{2}/)) {
      return a.label.localeCompare(b.label);
    }
    return 0;
  });

  const labels = dadosOrdenados.map((item) => item.label);
  const values = dadosOrdenados.map((item) => item.valor);

  // Calcular o valor máximo e adicionar margem para os rótulos
  const maxValue = Math.max(...values);
  const yMax = maxValue * 1.15; // 15% extra para os rótulos

  if (labels.length === 0 || values.length === 0) {
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
          <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>Processos por Mês</div>
        </div>
        <Message warning style={{ margin: 0 }}>
          Dados não estão no formato esperado
        </Message>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <div />
        {onExpandir && (
          <Button 
            icon 
            size="mini" 
            basic 
            onClick={() => onExpandir(dadosOrdenados, 'Por Mês')}
            title="Ver todos os meses"
          >
            <Icon name="expand" />
          </Button>
        )}
      </div>
      <Plot
        data={[
          {
            x: labels,
            y: values,
            type: "scatter",
            mode: "lines+markers+text",
            text: values,
            textposition: "top center",
            textfont: {
              size: 10,
              color: "#37536d",
            },
            line: { color: "#4183c4", width: 2 },
            marker: { size: 5, color: "#37536d" },
            fill: "tozeroy",
            fillcolor: "rgba(65, 131, 196, 0.15)",
            hovertemplate: "<b>%{x}</b><br>Processos: %{y}<extra></extra>",
          },
        ]}
        layout={{
          title: {
            text: "<b>POR MÊS</b>",
            font: {
              family: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
              size: 14,
              color: "#37536d",
            },
          },
          margin: { b: 80, l: 50, r: 40, t: 40 },
          xaxis: {
            title: "",
            showgrid: true,
            gridwidth: 1,
            gridcolor: "rgba(200,200,200,0.3)",
            tickangle: -45,
            automargin: true,
            range: [-0.5, labels.length - 0.5],
          },
          yaxis: {
            title: "",
            showgrid: true,
            gridwidth: 1,
            gridcolor: "rgba(200,200,200,0.3)",
            zeroline: false,
            automargin: true,
            range: [0, yMax],
          },
          plot_bgcolor: "white",
          paper_bgcolor: "white",
          hovermode: "x unified",
        }}
        config={{
          responsive: true,
          displayModeBar: false,
          toImageButtonOptions: {
            format: 'png',
            filename: 'processos_por_mes',
          },
        }}
        useResizeHandler={true}
        style={{ width: "100%", height: "280px" }}
      />
    </div>
  );
}

export default GraficoProcessosPorMes;
